import React, {useCallback, useEffect, useRef, useState} from "react";
import {ToolbarButton, useEditorContext} from "@graphiql/react";
import "graphiql/graphiql.min.css";
import "@graphiql/plugin-explorer/dist/style.css";
import copyToClipboard from "copy-to-clipboard";
import LinkIcon from "@atlaskit/icon/glyph/link";
import {stripIgnoredCharacters} from "graphql";

const MAX_URL_LENGTH = 2083;

const parseGQLWithDefault = (string, defaultString) => {
    try {
        return stripIgnoredCharacters(string);
    } catch {
        return defaultString;
    }
};
const minifyJSONWithDefault = (string, defaultString) => {
    try {
        return JSON.stringify(JSON.parse(string));
    } catch {
        return defaultString;
    }
};

function CopyLinkButton(props) {
    const suggestedUrl = useRef("");
    const [hasError, setHasError] = useState(false);
    const { queryEditor, headerEditor, variableEditor } = useEditorContext({
        nonNull: true,
        caller: CopyLinkButton,
    });

    const getPermalink = useCallback(() => {
        if (!queryEditor || !headerEditor || !variableEditor) {
            return "";
        }
        const headerSanitised = minifyJSONWithDefault(
            headerEditor.getValue(),
            null
        );
        const variablesSanitised = minifyJSONWithDefault(
            variableEditor.getValue(),
            null
        );
        const querySanitised = parseGQLWithDefault(
            queryEditor.getValue(),
            queryEditor.getValue()
        );

        const suggestedUrl = new URL(window.location.href);
        if (querySanitised) {
            suggestedUrl.searchParams.set("query", querySanitised);
        }
        if (variablesSanitised) {
            suggestedUrl.searchParams.set("variables", variablesSanitised);
        }
        if (headerSanitised) {
            suggestedUrl.searchParams.set("headers", headerSanitised);
        }

        return suggestedUrl.toString();
    }, [queryEditor, headerEditor, variableEditor]);
    const checkValidUrl = useCallback(() => {
        suggestedUrl.current = getPermalink();
        const queryTooLong = MAX_URL_LENGTH < suggestedUrl.current.length;
        setHasError(queryTooLong);
    }, [getPermalink]);

    useEffect(() => {
        if (hasError) {
            setTimeout(() => {
                setHasError(false);
              }, 5000);
        }
    }, [hasError])

    return (
        <ToolbarButton
            onClick={() => copyToClipboard(suggestedUrl.current)}
            onFocus={checkValidUrl}
            onMouseEnter={checkValidUrl}
            disabled={hasError}
            label={
                hasError
                    ? "Unable to copy URL, content too large."
                    : "Copy sharable link with query, variables & headers"
            }
            className={hasError && "error disabled-url-copy"}
        >
            <span className="graphiql-toolbar-icon">
                <LinkIcon aria-hidden="true" />
            </span>
        </ToolbarButton>
    );
}

export default CopyLinkButton;
